import { ShotFittingStatus } from './Golfer';
import SimulatorData from '../classes/SimulatorData';

export type ShotType = 'Full' | 'Pitch' | 'Open Face' | 'Bunker';

export const ShotTypeSortOrder = new Map<ShotType, number>([["Full", 1], ["Pitch", 2], ["Open Face", 3], ["Bunker", 4]]);  //used for Select Shots screen

export class ShotSelection {
    constructor(public shotType: ShotType, public selected: boolean, public priority: number, public upArrow = true, public downArrow = true) { }
}

export class PracticeShot {
    constructor(public status: ShotFittingStatus, public data?: SimulatorData) { }
}

export class ShotToPlot {
    attackAngle: number;
    shaftLean: number;
    totalShots: number;
}

export class ShotHistory {
    constructor(public id: string, public shotNumber: number, public loft: string, public shotType: string, public dynamicLoft: number, public attackAngle: string, public shaftLean: string,
        public ballSpeed: string, public launchAngle: number, public backSpin: number, public carryDistance: string, public headSpeed: string) { }
}

export const DefaultShotSelection =
    new Map<string, ShotSelection[]>([
        ["44", [new ShotSelection('Full', true, 0)]],
        ["46", [new ShotSelection('Full', true, 0)]],
        ["48", [new ShotSelection('Full', true, 0)]],
        ["50", [new ShotSelection('Full', true, 0), new ShotSelection('Pitch', false, 1), new ShotSelection('Open Face', false, 2)]],
        ["52", [new ShotSelection('Full', true, 0), new ShotSelection('Pitch', false, 1), new ShotSelection('Open Face', false, 2)]],

        ["54", [new ShotSelection('Pitch', true, 0), new ShotSelection('Full', true, 1), new ShotSelection('Open Face', false, 2), new ShotSelection('Bunker', false, 3)]],
        ["56", [new ShotSelection('Pitch', true, 0), new ShotSelection('Full', true, 1), new ShotSelection('Open Face', false, 2), new ShotSelection('Bunker', true, 3)]],

        ["58", [new ShotSelection('Open Face', true, 0), new ShotSelection('Pitch', true, 1), new ShotSelection('Full', true, 2), new ShotSelection('Bunker', true, 3)]],
        ["60", [new ShotSelection('Open Face', true, 0), new ShotSelection('Pitch', true, 1), new ShotSelection('Full', true, 2), new ShotSelection('Bunker', true, 3)]],
        ["62", [new ShotSelection('Open Face', true, 0), new ShotSelection('Pitch', true, 1), new ShotSelection('Full', false, 2), new ShotSelection('Bunker', true, 3)]],
    ]);
